import { useEffect, useMemo, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Breakpoint, useBreakpoint } from '@jove-frontend/uikit';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'next-share';
import {
  BlogPost,
  Category,
  renderRichText,
  sliceArticleInHalf,
} from '../../lib/blog';
import { useAuthStore } from '../../store/AuthStore';
import { BlogPostThumbnail } from './BlogPostThumbnail';
import { BlogRegister } from './BlogRegister';

type Props = {
  post: BlogPost;
};

const IconSizeLarge = 57;
const IconSizeSmall = 32;

export const BlogPostContent = ({ post }: Props) => {
  const { isAuthenticated } = useAuth0();
  const isCommunityUser = useAuthStore(({ state }) => state.isCommunityUser);
  const [pageUrl, setPageUrl] = useState<string>();
  const [iconSize, setIconSize] = useState(IconSizeLarge);
  const breakpoint = useBreakpoint();
  const articleContent = useMemo(
    () => renderRichText(post.article?.json, post.article?.links?.assets),
    [post]
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPageUrl(window.location.href);
    }
  }, []);

  useEffect(() => {
    if (breakpoint === Breakpoint.Small) {
      setIconSize(IconSizeSmall);
    } else {
      setIconSize(IconSizeLarge);
    }
  }, [breakpoint]);

  if (!pageUrl) return null;

  return (
    <div className="blog-post-content md:container">
      <div className="social-col col flex flex-col items-center space-y-6 pt-6">
        <LinkedinShareButton url={pageUrl} className="my-3">
          <LinkedinIcon
            size={iconSize}
            round
            bgStyle={{ fill: 'var(--brand-primary)' }}
          />
        </LinkedinShareButton>
        <TwitterShareButton url={pageUrl} title={post.title} className="my-3">
          <TwitterIcon
            size={iconSize}
            round
            bgStyle={{ fill: 'var(--brand-primary)' }}
          />
        </TwitterShareButton>
        <FacebookShareButton url={pageUrl} quote={post.title} className="my-3">
          <FacebookIcon
            size={iconSize}
            round
            bgStyle={{ fill: 'var(--brand-primary)' }}
          />
        </FacebookShareButton>
      </div>

      <div className="content-col col">
        <BlogPostThumbnail post={post} />

        <div className="content mb-8">
          {(!isAuthenticated || !isCommunityUser) &&
          post.category === Category.Help ? (
            <>
              {sliceArticleInHalf(articleContent)}
              <BlogRegister />
            </>
          ) : (
            articleContent
          )}
        </div>
      </div>
    </div>
  );
};
